function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["as", "children", "className", "classes", "hAlign", "hGutters", "noGutters", "vAlign", "vGutters"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
var Row = function Row(_ref) {
  var ComponentToRender = _ref.as,
    children = _ref.children,
    className = _ref.className,
    classesProp = _ref.classes,
    hAlign = _ref.hAlign,
    hGutters = _ref.hGutters,
    noGutters = _ref.noGutters,
    vAlign = _ref.vAlign,
    vGutters = _ref.vGutters,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(styles, classesProp);
  var containerClass = cx(className, classes.row, hAlign && styles["justify-content-".concat(hAlign)], vAlign && styles["align-items-".concat(vAlign)], _defineProperty({}, styles['no-gutters'], hGutters === false || noGutters), _defineProperty({}, styles['vertical-gutters'], vGutters));
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: containerClass
  }, props), children);
};
Row.defaultProps = {
  as: 'div',
  hGutters: true,
  noGutters: false,
  vGutters: false,
  className: ''
};
process.env.NODE_ENV !== "production" ? Row.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Class dependencies
   */
  classes: classesPropType(['row']),
  /**
   * Horizontally align columns within the row using flexbox
   */
  hAlign: PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * Horizontal gutters
   */
  hGutters: PropTypes.bool,
  /**
   * @deprecated
   *
   * Deprecated in favor of `hGutters={false}` in v8 (and will be removed in v9). Removes horizontal gutters from a row.
   */
  noGutters: PropTypes.bool,
  /**
   * Vertically align columns within the row using flexbox
   */
  vAlign: PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * Vertical gutters
   */
  vGutters: PropTypes.bool
} : void 0;
export default Row;